import { useOutletContext } from "react-router-dom";

import { Stack } from "@mui/material";
import { FormikErrorNotification, SaveBar } from "@shared";

import { CounselorResponse } from "@/api";
import { useTranslation } from "@/translations";

import { ContractualHoursCard } from "./components/contractual-hours-card/ContractualHoursCard";
import { WorkTimeAllocationCard } from "./components/work-time-allocation-card/WorkTimeAllocationCard";
import { useCounselorWorkTime } from "./hooks/useCounselorWorkTime";

export function CounselorWorkTime() {
  const { t } = useTranslation();
  const counselor = useOutletContext<CounselorResponse>();

  const { formik, teamOptions, workAreaOptions, handleAddAllocation, handleDeleteAllocation } = useCounselorWorkTime(
    counselor.counselorId
  );

  return (
    <Stack component="form" onSubmit={formik.handleSubmit} sx={{ flex: 1, maxHeight: "100%", gap: 1 }}>
      <FormikErrorNotification formik={formik} />

      <Stack flex={1} gap={1} sx={{ overflowY: "auto" }}>
        <ContractualHoursCard formik={formik} />
        <WorkTimeAllocationCard
          formik={formik}
          workAreaOptions={workAreaOptions}
          teamOptions={teamOptions}
          onAdd={handleAddAllocation}
          onDelete={handleDeleteAllocation}
        />
      </Stack>

      <SaveBar
        resetLabel={t("common.resetChanges")}
        onReset={formik.handleReset}
        resetDisabled={formik.isSubmitting || !formik.dirty}
        saveLabel={t("common.save")}
        saveDisabled={formik.isSubmitting || !formik.dirty}
      />
    </Stack>
  );
}
